import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { CSSProperties, ComponentProps, FC, PropsWithChildren } from "react";
import { transitionWithoutBounce } from "../utils/transitions";

const DrawerContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;

  overflow: hidden;
`;

const ContentContainer = styled.div`
  flex: 1;

  padding: 40px;

  display: flex;
  flex-direction: column;
  gap: 20px;

  background: white;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

  overflow: hidden;
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DrawerContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;

  overflow-y: auto;
`;

export const DrawerFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  justify-self: flex-end;
`;

type DrawerProps = PropsWithChildren<{
  isOpen: boolean;
  openSize: CSSProperties["width"];
  contentContainerProps?: ComponentProps<typeof ContentContainer>;
  direction?: "vertical" | "horizontal";
}>;
export const Drawer: FC<DrawerProps> = ({
  isOpen,
  openSize,
  contentContainerProps,
  direction = "vertical",
  children,
}) => {
  const size = isOpen ? openSize : 0;
  const animationProps =
    direction === "vertical"
      ? { minWidth: size, width: size }
      : { minHeight: size, height: size };
  return (
    <DrawerContainer
      initial={animationProps}
      animate={animationProps}
      transition={transitionWithoutBounce}
    >
      <ContentContainer {...contentContainerProps}>{children}</ContentContainer>
    </DrawerContainer>
  );
};
